import get from 'lodash/get';

const getToken = () => state => {
  return get(state, 'auth.accessToken', null);
};

export default getToken;
